import React, { useState } from "react";
import { toast } from "react-toastify";

interface Folder {
  folderId: number;
  entityName: string;
  parentId: number | null;
  isFile: boolean;
  children: Folder[];
  isLocked: any
  entityPath: any
  localPath: any
}

const FolderTree3 = React.memo(({ viewFilePerm, editFilePerm, folders, setIsFile, uploadFile, setSelectedParentId, setSelectedRowId, setSelectedFolderName }: any) => {
  const [selectedFolderId, setSelectedFolderId] = useState<number | null>(null);
  const [openFolders, setOpenFolders] = useState<Set<number>>(new Set());

  // Handle folder selection
  const handleFolderSelection = (folderId: number, folderName: any, parentId: any, isFile: any) => {
    setSelectedFolderId(folderId);
    setSelectedRowId(folderId);
    setSelectedFolderName(folderName);
    setSelectedParentId(parentId)
    setIsFile(isFile)
  };

  // Toggle folder open/close state
  const toggleFolder = (folderId: number) => {
    setOpenFolders((prev) => {
      const updated = new Set(prev);
      if (updated.has(folderId)) {
        updated.delete(folderId); // Close folder
      } else {
        updated.add(folderId); // Open folder
      }
      return updated;
    });
  };

  // Drag-and-drop handlers
  const handleDragStart = (event: React.DragEvent<HTMLDivElement>, folder: Folder) => {
    event.dataTransfer.setData("application/json", JSON.stringify(folder));
  };

  const handleDrop = async (event: React.DragEvent<HTMLDivElement>, targetFolder: Folder) => {
    event.preventDefault();
    const data = event.dataTransfer.getData("application/json");
    const draggedFolder = JSON.parse(data) as Folder;

    // Prevent dropping into itself or its own children
    if (draggedFolder.folderId === targetFolder.folderId || isChildOf(draggedFolder, targetFolder)) {
      return;
    }

    // Call API to move the folder
    await moveFolder(draggedFolder, targetFolder);
  };

  const handleDragOver = (event: React.DragEvent<HTMLDivElement>) => {
    event.preventDefault(); // Allow drop
  };

  // Check if a folder is a child of another folder
  const isChildOf = (dragged: Folder, target: Folder): boolean => {
    if (!target.children) return false;
    if (target.children.some((child) => child.folderId === dragged.folderId)) return true;
    return target.children.some((child) => isChildOf(dragged, child));
  };

  // Move folder logic
  const moveFolder = async (draggedFolder: Folder, targetFolder: Folder) => {
    const formData = new FormData();
    formData.append("FolderId", targetFolder.folderId.toString());
    formData.append("FolderName", targetFolder.entityName);
    formData.append("file", draggedFolder.entityName); // Simulated file data

    try {
      await uploadFile(formData).unwrap();
      toast.success(`Moved ${draggedFolder.entityName} to ${targetFolder.entityName}`);
    } catch (error) {
      toast.error("Failed to move file");
    }
  };

  // Component for a single folder or file
  const FolderItem: React.FC<{ folder: Folder; path: string, disabled?: boolean }> = ({ folder, path, disabled }) => {
    const isSelected = selectedFolderId === folder.folderId;
    const isOpen = openFolders.has(folder.folderId);

    const handleClick = () => {
      handleFolderSelection(folder.folderId, folder.entityName, folder.parentId, folder.isFile);
      if (!folder.isFile) toggleFolder(folder.folderId);
    };

    return (
      <div style={{ marginLeft: "20px" }}>
        <div
          style={{
            cursor: "pointer",
            display: "flex",
            alignItems: "center",
            backgroundColor: isSelected ? "#8080801f" : "transparent",
            padding: "5px",
            borderRadius: "4px",
            opacity: disabled ? 0.5 : 1,
          }}
          onClick={handleClick}
        // aria-disabled={disabled}
        >
          {!folder.isFile ? (
            <span style={{ marginRight: "8px" }}>{isOpen ? "📂" : "📁"}</span>
          ) : (
            <span style={{ marginRight: "8px" }}>📄</span>
          )}
          <div className="d-flex align-items-center justify-content-between w-100 ">
            {folder.isFile ? (
              <div>
                <p
                  className="mb-0"
                >
                  {/* {`${path} - ${folder.entityName}`} */}
                  {`${folder.entityName}`}

                </p>
              </div>
            ) :
              (
                // <span>{`${path} - ${folder.entityName}`}</span>
                <span>{`${folder.entityName}`}</span>
              )}
            <div className="d-flex gap-3">
              {folder.isFile && folder.localPath !== null ? (
                <>
                  {editFilePerm &&
                    <button className="btn btn-primary p-1">
                      <a
                        href={folder.localPath}
                        target="_blank"
                        className="text-light fs-12"
                        rel="noopener noreferrer"
                        download
                      >
                        {/* {`${folder.entityName}`} */}
                        Edit File
                      </a>
                    </button>
                  }
                </>
              ) :
                (
                  ""
                )

              }

              {folder.isFile ? (
                <>
                  {viewFilePerm &&
                    <button className="btn btn-primary p-1">
                      <a
                        href={folder.entityPath}
                        target="_blank"
                        className="text-light fs-12"
                        rel="noopener noreferrer"
                        download
                      >
                        {/* {`${folder.entityName}`} */}
                        View File
                      </a>
                    </button>
                  }
                </>
              ) :
                (
                  ""
                )

              }

            </div>

            {/* {disabled &&
            <span className="ms-4">{svgIcons?.LockIcon}</span>
          } */}
          </div>
        </div>
        {/* Render children if it's a folder and is open */}
        {isOpen && !folder.isFile && folder.children.length > 0 && (
          <div>
            {folder.children.map((child, index) => (
              <FolderItem
                key={child.folderId}
                folder={child}
                path={`${path}.${index + 1}`}
                disabled={child?.isLocked === 1}
              />
            ))}
          </div>
        )}
      </div>
    );
  };

  return (
    <div>
      {folders?.result?.map((folder: Folder, index: number) => (
        <FolderItem key={folder.folderId} folder={folder} path={`${index + 1}`} />
      ))}
    </div>
  );
});

export default FolderTree3;
